import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// Import components
import { Input } from 'components/elements';

// Import styles utilities
import { customMinResponsive, size } from 'components/styles';

const CodeField = ({ type = 'text', field, name = 'pin', autoComplete = 'false', form: { touched, errors }, placeholder, maxLength = '' }) => {
	return (
		<CodeFieldStyled>
			<StyledInput
				className={`${touched[field.name] && errors[field.name] ? 'errors' : ''}`}
				type={type}
				name={name}
				autoComplete={autoComplete}
				placeholder={placeholder}
				error={errors[field.name]}
				maxLength={maxLength}
				{...field}
			/>
		</CodeFieldStyled>
	);
};

const CodeFieldStyled = styled.div`
	width: 14rem;

	${customMinResponsive(
		size.small,
		css`
			width: 22rem;
		`
	)}
`;

const StyledInput = styled(Input)`
	text-align: center;
	color: ${({ theme, error }) => (error ? theme.palette.error : theme.user.tableItemName)};
	font-size: 2.8rem;
`;

CodeField.propTypes = {
	type: PropTypes.string.isRequired,
	field: PropTypes.object.isRequired,
	name: PropTypes.string,
	form: PropTypes.shape({
		touched: PropTypes.object.isRequired,
		errors: PropTypes.object.isRequired
	}),
	placeholder: PropTypes.string.isRequired,
	autoComplete: PropTypes.string,
	maxLength: PropTypes.number
};

export default CodeField;
